/* tnf-appbuz-popup.js — App download popup ("Download Our App / 15% OFF")
 *
 * What: Floating popup that prompts mobile shoppers to download the TNF native app.
 * Auto-detects iOS vs Android and links to the matching store.
 * Display rules: shows after first visit; hides 4 hours on close; hides 7 days on CTA click.
 *
 * Origin: Restored 2026-04-30 from previous Shopify CDN file
 * (topnutrition21Mar_pa-floater.js?v=1742530987). Renamed for clarity + self-owned
 * in theme assets (no longer a loose CDN file).
 *
 * Internal class names (PAFloater, PAFloaterContainer) and cookie names
 * (PAFLoaterVisitCount, PAFloaterKeepHidden) are intentionally KEPT THE SAME so
 * shoppers who previously dismissed the popup keep their hide state.
 *
 * To edit settings (title, links, timing): edit the `settings:` block below.
 */
window.PAFloater=function(){return{template:`
              <style>
              .PAFloater{
                  width:90vw;
                  margin:0 auto;
                  padding:10px 5px;
                  z-index:111;
                  background:{bgColor};
                  border: 1px solid {textColor}30;
                  border-radius: 10px;
                  margin-left: 20px !important
              }
              .PAFloaterClose{
                  position: absolute;
                  right: 3vw;
                  top: -1.5vw;
                  border-radius: 50%;
                  padding: 0;
                  height: 5vw;
                  width: 5vw;
                  line-height: 1;
                  background: #999;
                  font-size: 1em;
                  color: #fff;
                  border-color: transparent !important;
                  box-shadow: none !important;
                  outline: none !important;
                  cursor:pointer;
              }
              .PAFloater img{
                  width:15vh;
                  border-radius: 14px !important;
                  max-width: 60px !important;
                  max-height: none !important;
                  margin-top: 10px;
              }
              .PAFloaterDetails{
                  margin:5px;
              }
              .PAFloaterTitle{
                  text-transform:uppercase;
              }
              .PAFlexBox{
                  display: flex;
                  justify-content:space-around;
                  align-items:center;
              }
              h4.PAFloaterTitle {
                  text-align: center;
                  font-size: 12px;
                  font-weight: 700;
                  color: #4e4b4b;
              }

              h5.PABigText {
                  text-align: center;
                  font-size: 11px;
                  color: #000;
                  font-weight: 200;
              }

              .PACTA{
                  background-color: {ctaBgColor};
                  color: {ctaTextColor};
                  text-align: center;
                  text-decoration: none;
                  padding: 0.8em 1.2em;
                  border-radius: 10px;
              }
              .PAFloater p,h5,h4{
                  margin:.25em 0;
              }
              .PAsub-desc{
                  text-align: center;
                  color: #000;
                  font-weight: 200;
                  font-size: 11px;
              }
              </style>
              <div style="width:100vw;position:fixed;bottom: 10vh;z-index: 111;" id="PAFloaterContainer">
                  <div class="PAFloater" style="cursor:pointer" onclick="PAFloater.go()">
                  <button class="PAFloaterClose" onclick="event.stopPropagation();PAFloater.close()">X</button>
                  <div class="PAFlexBox">
                  <img src="{thumbnail}" alt="" />
                  <div class="PAFloaterDetails">
                  <h4 class="PAFloaterTitle">{title}</h4>
                  <h5 class="PABigText">{subtitle}</h5>
                  <p class="PAsub-desc">
                  {description}
                  </p>
                  </div>
                  <a id="pa-floater-cta" class="PACTA" href="{ctaLink}" target="_blank" onclick="event.stopPropagation();PAFloater.ctaClick()">{ctaTitle}</a>
                  </div>
                  </div>
                  </div>
              `,settings:{theme:{bgColor:"#ffffff",textColor:"#000000"},title:"Download Our App",subtitle:"Get 15% OFF on our app when you allow notifications",description:"",thumbnail:"https://cdn.shopify.com/s/files/1/1603/2381/files/460x0w.png?v=1735045689",playstore:"https://play.google.com/store/apps/details?id=topnutritionandfitness.android.app&pli=1",appstore:"https://apps.apple.com/us/app/top-nutrition/id6738488766",cta:{title:"GET",bgColor:"#000000",textColor:"#ffffff"},display:{minVisitCount:1,hideForHoursOnClose:4,hideForDaysOnCtaClick:7}},init:function(){if(this.settings.linkTo=this.getStore(),this.settings.linkTo){let t=parseInt(this.getCookie("PAFLoaterVisitCount"))||0,e=parseInt(this.getCookie("PAFloaterKeepHidden"))||0;if(t+=1,t>=this.settings.display.minVisitCount&&e==0){let s=this.template.replace("{bgColor}",this.settings.theme.bgColor).replace("{thumbnail}",this.settings.thumbnail).replace("{textColor}",this.settings.theme.textColor).replace("{title}",this.settings.title).replace("{subtitle}",this.settings.subtitle).replace("{description}",this.settings.description).replace("{ctaTitle}",this.settings.cta.title).replace("{ctaBgColor}",this.settings.cta.bgColor).replace("{ctaTextColor}",this.settings.cta.textColor).replace("{ctaLink}",this.settings[this.settings.linkTo]);document.body.insertAdjacentHTML("beforeend",s)}this.setCookie("PAFLoaterVisitCount",t,365)}},setCookie:function(name,value,hours){let expirationTime=new Date;expirationTime.setTime(expirationTime.getTime()+hours*60*60*1e3);let expires="expires="+expirationTime.toUTCString();document.cookie=name+"="+value+";"+expires+";path=/;"},getCookie:function(t){for(var e=t+"=",s=decodeURIComponent(document.cookie),i=s.split(";"),r=0;r<i.length;r++){for(var o=i[r];o.charAt(0)==" ";)o=o.substring(1);if(o.indexOf(e)==0)return o.substring(e.length,o.length)}return!1},getStore:function(){var t=navigator.userAgent||navigator.vendor||window.opera;return/windows phone/i.test(t)?!1:/android/i.test(t)?"playstore":/iPad|iPhone|iPod/.test(t)&&!window.MSStream?"appstore":!1},close:function(){document.getElementById("PAFloaterContainer").style.display="none",this.setCookie("PAFloaterKeepHidden",1,this.settings.display.hideForHoursOnClose)},ctaClick:function(){this.setCookie("PAFloaterKeepHidden",1,this.settings.display.hideForDaysOnCtaClick*24)},go:function(){this.ctaClick();window.open(this.settings[this.settings.linkTo],"_blank")}}}(),PAFloater.init();

/* === GA4 dataLayer events for the popup (added 2026-04-30) ============== */
/* Wraps PAFloater.close + .ctaClick AFTER init() so the inline onclick="" handlers
   in the rendered HTML still resolve to the wrapped methods. Fires:
   - tnf_appbuz_view  → when popup actually renders to the DOM
   - tnf_appbuz_close → when shopper taps the X
   - tnf_appbuz_cta_click → when shopper taps GET (links to App Store / Play Store) */
(function(){
  try {
    var dl = function(payload) {
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); } catch(e){}
    };
    if (typeof PAFloater === 'undefined') return;
    var store = (PAFloater.settings && PAFloater.settings.linkTo) || '';
    /* If popup actually rendered (passed cookie checks), fire view */
    if (document.getElementById('PAFloaterContainer')) {
      dl({ event: 'tnf_appbuz_view', store: store });
    }
    /* Wrap close */
    var origClose = PAFloater.close.bind(PAFloater);
    PAFloater.close = function() {
      try { dl({ event: 'tnf_appbuz_close', store: (this.settings && this.settings.linkTo) || '' }); } catch(e){}
      return origClose();
    };
    /* Wrap ctaClick */
    var origCta = PAFloater.ctaClick.bind(PAFloater);
    PAFloater.ctaClick = function() {
      try {
        var s = (this.settings && this.settings.linkTo) || '';
        var target = (this.settings && s && this.settings[s]) || '';
        dl({ event: 'tnf_appbuz_cta_click', store: s, target_url: target });
      } catch(e){}
      return origCta();
    };
  } catch(e){}
})();
